/* JC-EVO 09/26/2026: closing add-to-cart band, design B (jc-closing-buy.css). Loaded by
   sections/closing-addon-product.liquid. Progressive enhancement of the section's option <select>: a radio group of
   choice tiles (real <input type="radio"> in <label> tiles: native Tab / arrow keys / Space). Choosing a tile sets
   select.value and fires "change", so the section's own script still updates the hidden variant id, price, compare-at,
   Sale pill, photo and sold-out state; a change of the select from elsewhere is mirrored back. The select is hidden only
   once the tiles exist: if this file fails to load or throws, the plain select stays visible and works.
   Products with one variant render no select: nothing is built. Idempotent; re-runs on shopify:section:load. */
(function () {
  if (window.jcClosingBuy) return;
  window.jcClosingBuy = true;

  function enhance(root) {
    var sel = root.querySelector('select.cap__size-select');
    if (!sel || sel.dataset.jcTiles || !sel.options.length) return;
    var available = {};
    try {
      var data = JSON.parse(document.getElementById(sel.id.replace('cap-size-', 'cap-variants-')).textContent) || [];
      data.forEach(function (v) { available[String(v.id)] = v.available !== false; });
    } catch (e) { /* no data: no sold-out marks */ }

    var group = document.createElement('div');
    group.className = 'jc-cap-opts';
    group.setAttribute('role', 'radiogroup');
    var longest = 0;
    var inputs = Array.prototype.map.call(sel.options, function (o) {
      var text = o.textContent.trim();
      longest = Math.max(longest, text.length);
      var tile = document.createElement('label');
      tile.className = 'jc-cap-opt';
      var input = document.createElement('input');
      input.type = 'radio';
      input.className = 'jc-cap-opt__input';
      input.name = 'jc-cap-opt-' + sel.id;
      input.value = o.value;
      var box = document.createElement('span');
      box.className = 'jc-cap-opt__box';
      box.textContent = text;
      if (available[o.value] === false) {
        tile.setAttribute('data-soldout', '');
        var note = document.createElement('span');
        note.className = 'jc-cap-sr';
        note.textContent = ', sold out';
        box.appendChild(note);
      }
      input.addEventListener('change', function (e) {
        e.stopPropagation();                /* the tiles are private: page-level radio listeners never see them */
        if (input.checked && sel.value !== input.value) {
          sel.value = input.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      tile.appendChild(input);
      tile.appendChild(box);
      group.appendChild(tile);
      return input;
    });

    function sync() {
      inputs.forEach(function (input) { input.checked = input.value === sel.value; });
    }
    group.dataset.cols = longest > 18 ? '1' : (inputs.length === 3 && longest <= 8 ? '3' : '2');
    var label = root.querySelector('label.cap__size-label');
    if (label) {                            /* the label now names the radio group, not the hidden select */
      label.id = label.id || sel.id + '-label';
      label.removeAttribute('for');
      group.setAttribute('aria-labelledby', label.id);
    }
    sel.parentNode.insertBefore(group, sel.nextSibling);
    sel.addEventListener('change', sync);
    sync();
    sel.dataset.jcTiles = '1';
    sel.hidden = true;
  }

  function run() {
    document.querySelectorAll('.closing-addon-product').forEach(function (root) {
      try { enhance(root); } catch (e) { /* leave the plain select */ }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
